export const SEND_MESSAGE_PATH = '/sendmessage'
export const TEMPLATE_BASE_PATH = '/templates'
export const MESSAGES_SUBPATH = 'messages'
export const MESSAGE_TEMPLATE_NEW_SUBPATH = 'neu'
export const FORMS_TEMPLATE_SUBPATH = 'forms'
export const FORMS_EDITOR_PATH = 'formseditor'
export const VOUCHERS_SUBPATH = 'vouchers'
export const EMAIL_DESIGNS_SUBPATH = 'email-designs'
export const STUDIO_ASSETS_SUBPATH = 'assets'
export const AUTO_MESSAGE_SETTINGS_SUBPATH = MESSAGES_SUBPATH + '/' + 'auto'
export const AUTO_MESSAGE_SETTINGS_FULLPATH = TEMPLATE_BASE_PATH + '/' + AUTO_MESSAGE_SETTINGS_SUBPATH
export const FORMS_TEMPLATE_LIST_FULLPATH = TEMPLATE_BASE_PATH + '/' + FORMS_TEMPLATE_SUBPATH
export const VOUCHER_TEMPLATE_LIST_FULLPATH = TEMPLATE_BASE_PATH + '/' + VOUCHERS_SUBPATH
export const EMAIL_DESIGN_LIST_FULLPATH = TEMPLATE_BASE_PATH + '/' + EMAIL_DESIGNS_SUBPATH
export const STUDIO_ASSET_LIST_FULLPATH = TEMPLATE_BASE_PATH + '/' + STUDIO_ASSETS_SUBPATH

export const KISSSIGN_BASEPATH = '/kisssign'
export const KISSSIGN_AUTO_DELIVERY_SUBPATH = 'autodelivery'
export const KISSSIGN_AUTO_DELIVERY_FULLPATH = KISSSIGN_BASEPATH + '/' + KISSSIGN_AUTO_DELIVERY_SUBPATH

export const ARTISTS_BASEPATH = '/artists'
/** The mail settings of an artist, where an admin chooses the sender address. */
export const getArtistMailPath = (artistId) => `${ARTISTS_BASEPATH}/${artistId}/mail`

export const STUDIO_BASEPATH = '/studio'
export const STUDIO_BASE_SUBPATH = 'base'
export const STUDIO_BASE_FULLPATH =  [STUDIO_BASEPATH, STUDIO_BASE_SUBPATH].join('/')
export const STUDIO_SUBSCRIPTION_SUBPATH = 'subscription'
export const STUDIO_ABO_FULLPATH = [STUDIO_BASEPATH, STUDIO_SUBSCRIPTION_SUBPATH].join('/')
export const CUSTOMER_PORTAL_BASEPATH = '/customer-portal'
export const CUSTOMER_PORTAL_CONFIGURATION_SUBPATH = 'configuration'
export const CUSTOMER_PORTAL_CATEGORY_SUBPATH = 'category'
export const CUSTOMER_PORTAL_APPT_TYPE_SUBPATH = 'appointment-type'
export const CUSTOMER_PORTAL_PRODUCT_SUBPATH = 'product'
export const CUSTOMER_PORTAL_ARTIST_SUBPATH = 'artist'

export const STUDIO_LOCATIONS_SUBPATH = 'locations'
export const STUDIO_LOCATIONS_FULLPATH = [STUDIO_BASEPATH, STUDIO_LOCATIONS_SUBPATH].join('/')
export const STUDIO_MAIL_ADDRESSES_SUBPATH = 'mail-addresses'
export const STUDIO_MAIL_ADDRESSES_FULLPATH = [STUDIO_BASEPATH, STUDIO_MAIL_ADDRESSES_SUBPATH].join('/')
export const STUDIO_SHIFT_CONFIGURATION_SUBPATH = 'shift-configuration'
export const STUDIO_SHIFT_CONFIGURATION_FULLPATH = [STUDIO_BASEPATH, STUDIO_SHIFT_CONFIGURATION_SUBPATH].join('/')
export const STUDIO_APPOINTMENT_TYPES_SUBPATH = 'appointment-types'
export const STUDIO_APPOINTMENT_TYPES_FULLPATH = [STUDIO_BASEPATH, STUDIO_APPOINTMENT_TYPES_SUBPATH].join('/')
export const STUDIO_GGL_SYNC_SUBPATH = 'ggl-sync'
export const STUDIO_GGL_SYNC_FULLPATH = [STUDIO_BASEPATH, STUDIO_GGL_SYNC_SUBPATH].join('/')
export const STUDIO_V2_API_SUBPATH = 'v2-api'
export const STUDIO_V2_API_FULLPATH = [STUDIO_BASEPATH, STUDIO_V2_API_SUBPATH].join('/')
export const STUDIO_INVOICES_SUBPATH = 'invoices'
export const STUDIO_INVOICES_FULLPATH = [STUDIO_BASEPATH, STUDIO_INVOICES_SUBPATH].join('/')
export const STUDIO_LOCALIZATION_SUBPATH = 'localization'
export const STUDIO_LOCALIZATION_FULLPATH = [STUDIO_BASEPATH, STUDIO_LOCALIZATION_SUBPATH].join('/')
export const KUNDE = '/kunde'
export const KUNDEN_IMPORT = KUNDE + '/import'

export const TERMIN = '/termin'
export const TERMIN_ICALIMPORT = TERMIN + '/icalimport'

export const ANALYTICS_BASEPATH = '/analytics'
export const SHIFT_PLANNING_PATH = '/shift-planning'
